import React from "react";
import { Modal } from "../../../components";
import { generatePdfName } from "../../../utilities/esigningUtils";
import { Loading } from "components/panels";

interface Props {
  isOpen: boolean
  onClose: () => void
  documentId: number
  documentNumber: string
}

const PdfViewerModal = (props: Props) => {
  const { documentId, documentNumber } = props;

  const fileName = generatePdfName(documentNumber);

  const url = window.CoreApi.InvoiceV2.DownloadPdf.absoluteUrl(documentId, fileName, true);

  return <Modal
    displayHeader={false}
    isOpen={props.isOpen}
    handleClose={props.onClose}
    width="huge"
    height={"max"}
  >
    <div style={{
      position: "absolute",
      top: "40%",
      left: "50%",
      zIndex: 1
    }}>
      <Loading size="large" />
    </div>
    <iframe
      width="100%"
      height="100%"
      src={url}
      style={{ border: 0, zIndex: 2 }}
    />
  </Modal>;
};

export default PdfViewerModal;